<template>
    <div>
        <ConfirmPageBlock
            stepsLength="8"
            url="/trademark-renewal/step-1"
        ></ConfirmPageBlock>
    </div>
</template>

<script>
import ConfirmPageBlock from '@/components/blocks/ConfirmPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        ConfirmPageBlock,
    },
    created() {
        var link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', '/statement-of-use/confirm ');
        document.head.appendChild(link);
    },
    mounted() {
        this.$store.commit('header/setTotal', 0)
        to_top()
    }
}
</script>
